import { render, staticRenderFns } from "./hover-card.vue?vue&type=template&id=16283dd2&scoped=true&"
import script from "./hover-card.vue?vue&type=script&lang=js&"
export * from "./hover-card.vue?vue&type=script&lang=js&"
import style0 from "./hover-card.vue?vue&type=style&index=0&id=16283dd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16283dd2",
  null
  
)

component.options.__file = "hover-card.vue"
export default component.exports